import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Modal } from 'antd';
import { CodeSandboxOutlined } from '@ant-design/icons';
import { useCustomerContext, useProductContext } from '../context';

const PackageTypingToggleButton = () => {
  const location = useLocation();
  const { customer } = useCustomerContext();
  const { isPackageTypingEnabled, togglePackageTyping } = useProductContext();

  const [shouldRender, setShouldRender] = useState(false);
  const [visible, setVisible] = useState(false);

  const isVisible = customer?.id && location.pathname === '/products';

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      requestAnimationFrame(() => {
        setVisible(true);
      });
    } else {
      setVisible(false);
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isVisible]);

  const handleTogglePackageTyping = () => {
    if (isPackageTypingEnabled) {
      togglePackageTyping();
      return;
    }

    Modal.confirm({
      title: 'Paketno kucanje',
      content: 'Da li ste sigurni da želite uključiti paketno kucanje?',
      okText: 'Da, uključi',
      cancelText: 'Odustani',
      centered: true,
      onOk: togglePackageTyping,
    });
  };

  if (!shouldRender) return null;

  return (
    <Button
      type={isPackageTypingEnabled ? 'primary' : 'default'}
      shape="circle"
      icon={<CodeSandboxOutlined />}
      size="large"
      onClick={handleTogglePackageTyping}
      title="Paketno kucanje"
      style={{
        position: 'fixed',
        right: 5,
        bottom: 'calc(155px + env(safe-area-inset-bottom, 0px) + var(--product-keyboard-height, 0px))',
        zIndex: 1000,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      }}
    />
  );
};

export default PackageTypingToggleButton;
